import React from "react";
import dateFormat from "dateformat";
import { Link } from "react-router-dom";

export default function BlogEntryItem(props) {

    return (

        // <main className="blog-entry-item"> 
        <main className={props.postType === "example" ? "example" : ""}>

            <div className="blog-entry-image-div"><img src={`${props.coverImage}`} className="blog-entry-image"/></div>
            <div className="blog-entry-title-area">
                <h1><Link to={`/blog/${props.slug}`}>{props.title}</Link></h1>
                    <div className="tags">
                        <div className="tag-divisor"></div>
                        {props.tags.map((tag) => 
                        <span className="tag"> {tag} </span>)}
                    </div>
            </div>
            <div className="blog-preview-wrapper">
                <p className="blog-preview-text">{props.contentPreview}</p>
                <div className="blog-entry-details"> 
                    <p className="author">{props.author.name}</p>
                    <p className="date">{dateFormat(props.date, "dd mmm yyyy")}</p>
                </div>
            </div>
        </main>

    )
}